<script setup>
import InputText from "primevue/inputtext";
import { useField } from "vee-validate";
import { toRef, inject, watch } from "vue";

const props = defineProps({
  label: {
    default: "",
    type: String,
  },
  fieldId: {
    default: "",
    type: String,
  },
});

const { value, errors } = useField(
  toRef(props.fieldId, "name"),
  { required: true, min: 3, max: 8 },
  {
    validateOnMount: true,
    label: props.label,
  }
);

const locale = inject("locale");
watch(locale, () => {
  const oldValue = value.value;
  value.value = "";
  value.value = oldValue;
});
</script>
<script>
export default {
  // eslint-disable-next-line vue/no-reserved-component-names
  name: "Input",
};
</script>
<template>
  <label>{{ label }}</label>
  <InputText v-model="value" id="qwe" />
  <p>{{ errors[0] }}</p>
</template>

<style scoped>
label {
  display: block;
}
</style>
